module.exports = __webpack_public_path__ + "assets/img/logAudit-module5-5.3c42c4b6.jpg";